export default {
  admin: () => import("/home/circleci/project/layouts/admin.vue").then(m => m.default || m),
  default: () => import("/home/circleci/project/layouts/default.vue").then(m => m.default || m),
  kiosk: () => import("/home/circleci/project/layouts/kiosk.vue").then(m => m.default || m),
  register: () => import("/home/circleci/project/layouts/register.vue").then(m => m.default || m)
}